{
    "Profile_SupernovaCommercial_LossPayees.lossPayeesInfo": "Loss Payees Info",
    "Profile_SupernovaCommercial_LossPayees.details": "Details",
    "Profile_SupernovaCommercial_LossPayees.haveAnyLossPayees": "Do you have any Loss Payees?",
    "Profile_SupernovaCommercial_LossPayees.lossPayees": "Loss Payees"
}
